<template>
    <div>
        <div class="row">
            <div class="col-xs-12 col-lg-3">
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="title" aria-label="Title">Title</span>
                    </div>
                    <select :value="value.title" 
                        @change="updateValue('title', $event.target.value); $v.value.title.$touch()" 
                        class="form-control" :class="{ invalid: $v.value.title.$error }">
                        <option disabled selected value="" aria-placeholder="Select Title">Select</option>
                        <option v-for="title in titles" :key="title.titleId" :value="title.name"
                                :aria-placeholder="title.name"
                                class="form-control-item">{{ title.name }}</option>
                    </select>
                </div>
                <div v-if="$v.value.title.$error" class="validation-message mb-3">Please select your title</div>
            </div>
            <div class="col-xs-12 col-lg">
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">First name</span>
                    </div>
                    <input class="form-control" :class="{ invalid: $v.value.firstName.$error }" type="text" placeholder="John" 
                        @blur="$v.value.firstName.$touch()"
                        :value="value.firstName" @input="updateValue('firstName', $event.target.value)" />
                </div>
                <div v-if="$v.value.firstName.$error" class="validation-message mb-3">Please enter your first name</div>
            </div>
            <div class="col-xs-12 col-lg">
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Last name</span>
                    </div>
                    <input class="form-control" :class="{ invalid: $v.value.lastName.$error }" type="text" placeholder="Smith" 
                        @blur="$v.value.lastName.$touch()"
                        :value="value.lastName" @input="updateValue('lastName', $event.target.value)" />
                </div>
                <div v-if="$v.value.lastName.$error" class="validation-message mb-3">Please enter your last name</div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md">
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Email Address</span>
                    </div>
                    <input class="form-control" :class="{ invalid: $v.value.email.$error }" 
                           type="email" placeholder="example@example.com"
                        :value="value.email" 
                        @blur="$v.value.email.$touch()"
                        @input="updateValue('email', $event.target.value)" /> 
                </div>
                <div v-if="$v.value.email.$error && !$v.value.email.required" class="validation-message mb-3">Please enter an email address</div>
                <div v-if="$v.value.email.$error && !$v.value.email.email" class="validation-message mb-3">Please enter a valid email address</div>
            </div>
        </div>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
    props: [ 'value' ],
    computed: {
        titles() { 
            return this.$store.state.static.titles;
        }
    },
    methods: { 
        updateValue(key, value) {
            this.$emit('input', { ...this.value, [key]: value });
        }
    },
    validations: {
        value: {
            required,
            title: { required },
            firstName: { required },
            lastName: { required },
            email: {
                required,
                email
            }
        }
    },
}
</script>